import FullWidthImageSlider from "../../../../src/components/FullWidthImageSlider";
import Slide from "../../../../src/components/FullWidthImageSlider/Slide";
import ImageReservationHistory from "../../../../src/content/blog-posts/how-do-payments-work-for-dog-sitters/image1.png";
import * as React from 'react';
export default {
  FullWidthImageSlider,
  Slide,
  ImageReservationHistory,
  React
};